/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "../../components/MDBox";

// Settings page components
import Sidenav from "./components/Sidenav/side_nav";
import BasicInfo from "./components/BasicInfo/basic_info";
import ChangePassword from "./components/ChangePassword";
import Generales from "../estudiantes/perfil/estudiantes_perfil";
import { ESTUDIANTE, FIRMANTE } from "../../roles";
import EntidadInfo from "./components/Entidad Info/entidad_info";
import FirmanteInfo from "./components/Firmante Info/firmante_Info";
import { useState } from "react";

function Home() {
  const user = JSON.parse(sessionStorage.getItem("user"));

  // Construir ítems dinámicamente según el usuario
  const items = [];
  const showEntidad = !user.is_staff && user.groups[0]?.name !== ESTUDIANTE;
  const showBasicInfo =
    user.groups[0]?.name !== ESTUDIANTE || user.groups[0]?.isStaff;
  const isFirmante = user.perfil.resourcetype.some(
    (e) => e.resourcetype === FIRMANTE
  );

  if (showEntidad) {
    items.push({
      label: "Información de Entidad",
      description: "Detalles sobre la información de la entidad",
      href: "entidad-info",
    });
  }

  items.push({
    label: "Información Básica",
    description: "Detalles sobre la información básica",
    href: showBasicInfo ? "basic-info" : "basic-estudiante-info",
  });

  if (isFirmante) {
    items.push({
      label: "Cargo de la persona",
      description: "Detalles sobre el cargo de la persona",
      href: "cargo-persona",
    });
  }

  items.push({
    label: "Contraseña",
    description: "Detalles sobre su seguridad",
    href: "change-password",
  });

  // Estado de selección controlado por el padre
  const [selected, setSelected] = useState(items[0]?.href || "change-password");

  // Render de contenido según selección
  const renderSelected = () => {
    switch (selected) {
      case "entidad-info":
        return showEntidad ? <EntidadInfo id="entidad-info" /> : null;
      case "basic-info":
        return showBasicInfo ? <BasicInfo id="basic-info" /> : null;
      case "basic-estudiante-info":
        return !showBasicInfo ? <Generales id="basic-estudiante-info" /> : null;
      case "cargo-persona":
        return isFirmante ? <FirmanteInfo id="cargo-persona" /> : null;
      case "change-password":
      default:
        return <ChangePassword id="change-password" />;
    }
  };

  return (
    <MDBox mt={4}>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={4} mt={10} alignItems={"center"}>
          <Sidenav items={items} selected={selected} onSelect={setSelected} />
        </Grid>
        <Grid item xs={12} lg={8}>
          <MDBox mb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {renderSelected()}
              </Grid>
            </Grid>
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Home;
